module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "board-prospect"
  }, [_c('h2', {
    staticClass: "dashboard-title dashboard-title--medium"
  }, [_vm._v("Parcours prospects")]), _vm._v(" "), _c('div', {
    staticClass: "board-prospect__searchbar"
  }, [_c('SearchForm', {
    attrs: {
      "placeholder": "Rechercher un prospect..."
    },
    on: {
      "search": _vm.handleSearch,
      "clear": _vm.handleClearSearch
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "dashboard-btn dashboard-btn--primary",
    on: {
      "click": _vm.openAddContactModal
    }
  }, [_vm._v("\n\t\t\tNouveau prospect\n\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "board-prospect__steps"
  }, [_c('BoardProspectSteps', {
    attrs: {
      "search-query": _vm.searchQuery
    }
  })], 1), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.showAddContact,
      "content": _vm.contentModal,
      "data": _vm.modalData
    },
    on: {
      "close": _vm.closeAddContactModal
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a17db6d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Board/BoardProspect.vue
// module id = 1102
// module chunks = 0